import { render, staticRenderFns } from "./invite-rules.vue?vue&type=template&id=6ce83b38&scoped=true&"
import script from "./invite-rules.vue?vue&type=script&lang=js&"
export * from "./invite-rules.vue?vue&type=script&lang=js&"
import style0 from "./invite-rules.vue?vue&type=style&index=0&id=6ce83b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce83b38",
  null
  
)

export default component.exports